<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="card">
      <div class="card-datatable mt-6">
        <div class="dataTables_scroll" bis_skin_checked="1">
          <div
            class="dataTables_scrollBody table-container"
            bis_skin_checked="1"
            style="position: relative; overflow: auto; width: 100%; height: 480px;"
          >
            <table
              class="dt-scrollableTable table"
              id="DataTables_Table_0"
              aria-describedby="DataTables_Table_0_info"
            >
              <thead
                style="background-color: var(--bs-card-bg);"
                class="sticky top-0 z-50"
              >
                <tr class="text-nowrap">
                  <th class="sorting">الخدمة</th>
                  <th class="sorting">الحالة</th>
                  <th class="sorting">العملية</th>
                </tr>
              </thead>
              <tbody class="table-border-bottom-0 ">
                <tr>
                  <td class="font-bold">SSRadius Local Tunnel</td>
                  <td>
                    <span class="badge bg-label-success me-1">Connected</span>
                  </td>
                  <td><div class="btn btn-danger">Restart</div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SServices",
};
</script>
